// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");

function MandatoryMessage(props) {
  var __language = props.language;
  var language = __language !== undefined ? __language : SurveyLanguage$ReactHooksTemplate.default;
  return JsxRuntime.jsxs("p", {
              children: [
                "*",
                JsxRuntime.jsx("span", {
                      children: SurveyLanguage$ReactHooksTemplate.message(language, "mandatory"),
                      className: "text-xs"
                    })
              ],
              className: " w-full pt-6 small:pt-3 text-lg "
            });
}

var make = MandatoryMessage;

exports.make = make;
/* react/jsx-runtime Not a pure module */
